const KEY = "orbit_desktop";

if (typeof window !== "undefined" && new URLSearchParams(window.location.search).get("desktop") === "1") {
  localStorage.setItem(KEY, "1");
  const u = new URL(window.location.href); u.searchParams.delete("desktop"); window.history.replaceState(null, "", u.toString());
}

export const isDesktop = () => localStorage.getItem(KEY) === "1" || window.matchMedia?.("(display-mode: standalone)").matches || window.matchMedia?.("(display-mode: fullscreen)").matches || window.matchMedia?.("(display-mode: window-controls-overlay)").matches || window.navigator.standalone === true;

const EDIT_OK = new Set(["c", "v", "x", "a", "z", "y", "p"]);
const isField = (el) => !!el?.closest?.("input,textarea,[contenteditable]");

const lock = () => {
  document.documentElement.dataset.desktop = "1";
  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };
  window.addEventListener("contextmenu", stop, true);
  window.addEventListener("keydown", (e) => {
    const k = e.key;
    const ctrl = e.ctrlKey || e.metaKey;
    if (k === "F12" || (e.altKey && ["ArrowLeft", "ArrowRight", "Home", "d", "D"].includes(k))) return stop(e);
    if (ctrl && e.shiftKey) return stop(e);
    if (ctrl && k.length === 1 && !(EDIT_OK.has(k.toLowerCase()) && (isField(e.target) || /^[acp]$/i.test(k)))) return stop(e);
  }, true);
  window.addEventListener("dragstart", stop, true);
  window.addEventListener("auxclick", stop, true);
  window.addEventListener("mousedown", (e) => { if (e.button === 1 || e.button === 3 || e.button === 4) stop(e); }, true);
  const allowed = (u) => { try { const x = new URL(u, window.location.origin); return x.origin === window.location.origin || /(^|\.)wa\.me$|whatsapp\.com$/.test(x.hostname); } catch { return false; } };
  document.addEventListener("click", (e) => { const a = e.target.closest?.("a[href]"); if (a && /^https?:/.test(a.getAttribute("href")) && !allowed(a.href)) stop(e); }, true);
  const open = window.open.bind(window);
  window.open = (u, ...r) => (allowed(u || "") ? open(u, ...r) : null);
};

if (typeof window !== "undefined" && isDesktop()) lock();
